import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className="relative bg-black text-white" data-id="element-1464">
      {/* Sticky Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-[100] transition-all duration-300 ${isScrolled ? 'bg-black/95 backdrop-blur-sm shadow-lg' : 'bg-transparent'}`} data-id="element-1465">
        <div className="max-w-[1200px] mx-auto px-4 lg:px-8" data-id="element-1466">
          <div className="flex h-16 lg:h-20 items-center justify-between" data-id="element-1467">
            {/* Logo */}
            <div className="flex items-center gap-2 flex-shrink-0" data-id="element-1468">
              <img src="https://cdn.magicpatterns.com/uploads/hrXX85rhn4YR9sbdgFXsGs/beclinical.svg_(1).png" alt="Be Clinical" className="h-10 w-auto" data-id="element-1469" />
            </div>

            {/* Desktop Nav */}
            <div className="hidden lg:flex items-center gap-6 xl:gap-8" data-id="element-1470">
              <a href="/about" className="text-[13px] uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors relative after:absolute after:bottom-[-2px] after:left-0 after:w-0 after:h-[1px] after:bg-[#FF1493] after:transition-all hover:after:w-full" data-id="element-1471">
                About Us
              </a>
              <a href="/treatments" className="text-[13px] uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors relative after:absolute after:bottom-[-2px] after:left-0 after:w-0 after:h-[1px] after:bg-[#FF1493] after:transition-all hover:after:w-full" data-id="element-1472">
                Treatments
              </a>
              <a href="/financing" className="text-[13px] uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors relative after:absolute after:bottom-[-2px] after:left-0 after:w-0 after:h-[1px] after:bg-[#FF1493] after:transition-all hover:after:w-full" data-id="element-1473">
                Financing
              </a>
              <a href="/testimonials" className="text-[13px] uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors relative after:absolute after:bottom-[-2px] after:left-0 after:w-0 after:h-[1px] after:bg-[#FF1493] after:transition-all hover:after:w-full" data-id="element-1474">
                Testimonials
              </a>
              <a href="#specials" className="text-[13px] uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors relative after:absolute after:bottom-[-2px] after:left-0 after:w-0 after:h-[1px] after:bg-[#FF1493] after:transition-all hover:after:w-full" data-id="element-1475">
                Specials
              </a>
              <a href="#membership" className="text-[13px] uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors relative after:absolute after:bottom-[-2px] after:left-0 after:w-0 after:h-[1px] after:bg-[#FF1493] after:transition-all hover:after:w-full" data-id="element-1476">
                Membership
              </a>
              <a href="/blog" className="text-[13px] uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors relative after:absolute after:bottom-[-2px] after:left-0 after:w-0 after:h-[1px] after:bg-[#FF1493] after:transition-all hover:after:w-full" data-id="element-1477">
                Blog
              </a>
              <Button variant="primary" size="sm" data-id="element-1478">
                Book Consult
              </Button>
            </div>

            {/* Mobile Menu Button */}
            <button className="lg:hidden p-2 text-white" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label={isMenuOpen ? 'Close menu' : 'Open menu'} data-id="element-1479">
              {isMenuOpen ? <XIcon size={24} data-id="element-1480" /> : <MenuIcon size={24} data-id="element-1481" />}
            </button>
          </div>
        </div>

        {/* Mobile Full-Screen Overlay */}
        {isMenuOpen && <div className="lg:hidden fixed inset-0 z-50 bg-[#111111] overflow-y-auto flex flex-col items-center justify-center gap-8 p-8 pt-24" data-id="element-1482">
            {/* Close Button */}
            <button onClick={() => setIsMenuOpen(false)} className="absolute top-6 right-6 p-2 text-white hover:text-[#FF1493] transition-colors" aria-label="Close menu" data-id="element-1483">
              <XIcon size={28} data-id="element-1484" />
            </button>

            <a href="/about" onClick={() => setIsMenuOpen(false)} className="text-lg uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors font-heading" data-id="element-1485">
              About Us
            </a>
            <a href="/treatments" onClick={() => setIsMenuOpen(false)} className="text-lg uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors font-heading" data-id="element-1486">
              Treatments
            </a>
            <a href="/financing" onClick={() => setIsMenuOpen(false)} className="text-lg uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors font-heading" data-id="element-1487">
              Financing
            </a>
            <a href="/testimonials" onClick={() => setIsMenuOpen(false)} className="text-lg uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors font-heading" data-id="element-1488">
              Testimonials
            </a>
            <a href="#specials" onClick={() => setIsMenuOpen(false)} className="text-lg uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors font-heading" data-id="element-1489">
              Specials
            </a>
            <a href="#membership" onClick={() => setIsMenuOpen(false)} className="text-lg uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors font-heading" data-id="element-1490">
              Membership
            </a>
            <a href="/blog" onClick={() => setIsMenuOpen(false)} className="text-lg uppercase tracking-widest text-white hover:text-[#FF1493] transition-colors font-heading" data-id="element-1491">
              Blog
            </a>
            <Button variant="primary" size="lg" className="w-full max-w-xs mt-4" onClick={() => setIsMenuOpen(false)} data-id="element-1492">
              Book Consult
            </Button>
          </div>}
      </nav>

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center overflow-hidden" data-id="element-1493">
        {/* Background Image */}
        <div className="absolute inset-0" data-id="element-1494">
          <img src="https://cdn.magicpatterns.com/uploads/cXSJ6Wb4UVSUBkp5LwdwNB/Be_Clinical_Hero_Image_Text.png" alt="Woman receiving beauty treatment with glowing skin, hands in black medical gloves framing her face" className="h-full w-full object-cover object-center" data-id="element-1495" />
          {/* Gradient overlay */}
          <div className="absolute inset-0 bg-gradient-to-r from-black via-black/50 to-transparent" data-id="element-1496"></div>
          <div className="absolute inset-0 bg-black/30 lg:bg-transparent" data-id="element-1497"></div>
        </div>

        {/* Decorative Script Words - hidden on mobile */}
        <div className="absolute inset-0 hidden md:block pointer-events-none z-10" data-id="element-1498"></div>

        {/* Hero Content */}
        <div className="relative z-20 w-full max-w-[1200px] mx-auto px-6 lg:px-8 pt-28 pb-16 lg:pt-0 lg:pb-0" data-id="element-1499">
          <div className="max-w-2xl" data-id="element-1500">
            {/* Main Headline - BE EXCELLENT */}
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-[80px] uppercase tracking-tight mb-6 text-center font-[500] font-[Poppins,_sans-serif] text-[#FF1493]" data-id="element-1501">
              BE EXCELLENT
            </h1>

            {/* Diamond Shape */}
            <div className="flex justify-center mb-8 items-center" data-id="element-1502">
              <img src="https://cdn.magicpatterns.com/uploads/uu9vckamxznJfhWXHg2VLM/Vector_12_(1).png" alt="" className="h-auto" style={{
              width: '18px'
            }} data-id="element-1503" />
            </div>

            {/* Subheadline */}
            <h2 className="font-serif italic text-2xl sm:text-3xl md:text-4xl lg:text-[42px] text-white leading-[1.2] mb-10 text-center" data-id="element-1504">
              The Art of Aesthetics.
              <br data-id="element-1505" />
              The Science of You.
            </h2>

            {/* CTA */}
            <div className="flex justify-center items-center" data-id="element-1506">
              <Button variant="primary" size="lg" className="w-full sm:w-auto min-h-[52px] px-10 text-sm tracking-widest" data-id="element-1507">
                SCHEDULE CONSULTATION
              </Button>
            </div>
          </div>
        </div>
      </section>
    </header>;
}